import * as PropTypes from 'prop-types';

const curePropTypes = {
  cure: PropTypes.object,
  type: PropTypes.string,
  className: PropTypes.string,
  needUnlikeConfirm: PropTypes.bool,
  onUnlikeSuccess: PropTypes.func
};

export { curePropTypes };
